import { Redirect } from 'react-router-dom';

import { ROUTES } from 'constants/routes';
import { getMod } from 'services/hooks';

export const LifeDashboard = () => {
  const Screen = getMod('gauges')?.screens.LifeDashboard;

  if (Screen) {
    return <Screen />;
  }

  return <Redirect to={ROUTES.home} />;
};
